import { render, staticRenderFns } from "./ProductTagMini.vue?vue&type=template&id=11b34f5c&"
import script from "./ProductTagMini.vue?vue&type=script&lang=js&"
export * from "./ProductTagMini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11b34f5c')) {
      api.createRecord('11b34f5c', component.options)
    } else {
      api.reload('11b34f5c', component.options)
    }
    module.hot.accept("./ProductTagMini.vue?vue&type=template&id=11b34f5c&", function () {
      api.rerender('11b34f5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProductTagMini.vue"
export default component.exports